import "../Style.css";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { closeVideo } from "../../../store/reviewReducer";
import InfoHeader from "../../features/common/InfoHeader";
import TabNavigation from "../../features/common/TabNavigation";
import OverviweTab from "../ReviewTabsPage/OverviweTab";
import InterviewQuestionTab from "../ReviewTabsPage/InterviewQuestionTab";
import ScoreTab from "../ReviewTabsPage/CompetencyScore/ScoreTab";
import TranscriptTab from "../ReviewTabsPage/TranscriptTab";


const InterviewReviewVideo = () => {
  const tabs = [
  { id: "overview", label: "Overview", icon: "eye", content: <OverviweTab /> },
  { id: "questions", label: "Questions & Responses", icon: "user", content: <InterviewQuestionTab /> },
  { id: "scores", label: "Competency Scores", icon: "award", content: <ScoreTab /> },
  { id: "transcript", label: "Full Transcript", icon: "clock", content: <TranscriptTab /> },
];

const [activeTab, setActiveTab] = useState("overview");
  const dispatch = useDispatch();
  const closeVidePage = () => {
    dispatch(closeVideo());
  };
  return (
    <>
      <div className="flex items-center justify-between">
        <InfoHeader
          title="Sarah Johnson"
          subtitle="Agency Paid Media - Meta and Google • 2024-01-15"
          status="completed"
          score={78}
          onClose={() => closeVidePage()}
          onAction={() => console.log("Export clicked")}
          actionLabel="Export Report"
          actionIcon="download"
        />
      </div>
      <div className="bg-white rounded-lg border border-gray-200">
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabClick={(tabId) => setActiveTab(tabId)}
        />
        <div className="p-6">
          <div className="space-y-6">
            {tabs.find((t) => t.id === activeTab)?.content}
          </div>
        </div>
      </div>
    </>
  );
};

export default InterviewReviewVideo;
